import(/* webpackMode: "eager" */ "/app/src/app/(default)/error.tsx");
